
<div class="row desktopInfringement" *ngIf="cardType === '' ">
    <div class="col-1">
      <h3 class="txt txt--section">
        {{ infractionIndex +1}}
      </h3>
    </div>
    <div class="col-11">
      <div class="row">
        <div class="col-md-4">
          <div class="infringement__status infringement__status--inactive"
            [ngClass]="{'infringement__status--active': infraction.infractionState === 1}">
            Infracción {{infraction.infractionStateDescription | lowercase}}
          </div>
          <div class="form">
            <label for="" class="label">
              {{infraction.asset}}
            </label>
            <p class="txt txt--small">
              Zona {{infraction.infringementZone | titlecase }}
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              {{infraction.suspensionType}}
            </label>
            <p class="txt txt--small" *ngIf="infraction.suspensionStartAt && infraction.suspensionEndAt">
              Del {{infraction.suspensionStartAt | dateFromBack }} al
              {{infraction.suspensionEndAt | dateFromBack }}
            </p>
            <p class="txt txt--small" *ngIf="infraction.suspensionStartAt && !infraction.suspensionEndAt">
              Desde {{infraction.suspensionStartAt | dateFromBack }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form">
            <label for="" class="label">
              Infracción {{infraction.infringmentSeverity}}
            </label>
            <p class="txt txt--small">
              {{ infraction.infringementType }}
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              Comentario:
            </label>
            <p class="txt txt--small">
              {{infraction.infringmentObservations}}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form">
            <label for="" class="label">
              Carga - camión articulado
            </label>
            <p class="txt txt--small txt--grey">
              {{infraction.vehicleType}}
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              Patente:
            </label>
            <p class="txt txt--small txt--grey">
              {{infraction.vehiclePatent}}
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              Registro
            </label>
            <p class="txt txt--small" *ngIf="infraction.dateRegister">
              {{infraction.dateRegister | dateFromBack }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mobileInfringement" *ngIf="cardType === '' ">
    <div class="col-12">
      <div class="row">
        <div class="col-md-4">
          <div class="infringement__status infringement__status--inactive"
            [ngClass]="{'infringement__status--active': infraction.infractionState === 1}" style="padding-left: 25px;">
            <span style="font-size: 14px;position: absolute;top:6px; left: 20px;">{{ infractionIndex +1}}</span>
            <span style="font-size: 14px;"> Infracción {{infraction.infractionStateDescription | lowercase}} </span> <br>
            <label style="font-size: 16px;">
                {{infraction.suspensionType}}
            </label>
            <p class="txt txt--small" style="color:white;font-size: 14px;margin-bottom: 3px !important;" *ngIf="infraction.suspensionStartAt && infraction.suspensionEndAt">
                Del {{infraction.suspensionStartAt | dateFromBack }} al
                {{infraction.suspensionEndAt | dateFromBack }}
            </p>
          </div>

          <div class="form" style="display:flex;display: -webkit-flex;
          display:-ms-flexbox;justify-content: space-between;margin-bottom: 0 !important;padding-left:5px;padding-right: 5px;">
            <label for="" class="label">
              Carga - camión articulado
              <p class="txt txt--small txt--grey">
                {{infraction.vehicleType}}
              </p>
            </label>

            <label for="" class="label">
              Patente:
            </label>
            <p class="txt txt--small txt--grey">
              {{infraction.vehiclePatent}}
            </p>
          </div>

          <div class="form" style="padding-left:5px;padding-right: 5px;">

                <label class="label">
                  Infracción {{infraction.infringmentSeverity}}
                </label>
                <p class="txt txt--small">
                  {{ infraction.infringementType }}
                </p>
                <label class="label">
                    {{infraction.asset}}
                  </label>
                  <p class="txt txt--small">
                    Zona {{infraction.infringementZone | titlecase }}
                </p>
                <label for="" class="label">
                    Registro
                </label>
                  <p class="txt txt--small" *ngIf="infraction.dateRegister">
                    {{infraction.dateRegister | dateFromBack }}
                  </p>
          </div>
        </div>
        <div class="col-md-4">
            <div style="padding-left:5px;padding-right: 5px;">
                <div class="form">
                  <label for="" class="label">
                    Comentario:
                  </label>
                  <p class="txt txt--small">
                    {{infraction.infringmentObservations}}
                  </p>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card de infracción para searchInfraction -->
  <div class="" *ngIf="cardType === 'search'">
    <div class="row">
        <div class="col-1">
            <h3 class="txt txt--section">
              {{ infractionIndex +1}}
            </h3>
        </div>
        <div class="col-11">
            <div class="row">
                <div class="col-md-4">
                    <div class="infringement__status infringement__status--inactive"
                    [ngClass]="{'infringement__status--active': infraction.infractionState === 1}">
                        Infracción {{ infraction.infractionStateDescription | lowercase }}
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            {{infraction.asset}}
                        </label>
                        <p class="txt txt--small">
                            {{infraction.infringementZone}}
                        </p>
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            Tipo de vehículo
                        </label>
                        <p class="txt txt--small txt--grey">
                          {{infraction.vehicleType}}
                        </p>
                    </div>
                    <div class="form u-mb20">
                      <label for="" class="label">
                        Patente:
                      </label>
                      <p class="txt txt--small txt--grey">
                        {{infraction.vehiclePatent}}
                      </p>
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            Día de la infracción
                        </label>
                        <p class="txt txt--small">
                          {{infraction.infringementDate | date: 'dd/MM/yyyy'}}
                        </p>
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            Hora de la infracción
                        </label>
                        <p class="txt txt--small">
                          {{infraction.infringementHour}}
                        </p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form">
                        <label for="" class="label">
                            Responsable del infractor
                        </label>
                        <p class="txt txt--small">
                          {{infraction.offendersResponsable}} &nbsp;
                        </p>
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            Infracción {{infraction.infringmentSeverity}}
                        </label>
                        <p class="txt txt--small">
                          {{infraction.infringementType}}
                        </p>
                    </div>
                    <div class="form">
                        <label for="" class="label">
                            Comentario:
                        </label>
                        <p class="txt txt--small">
                          {{infraction.infringmentObservations}}
                        </p>
                    </div>
                </div>
                <div class="col-md-4">

                    <div class="form">
                      <label for="" class="label">
                          Quien reporta la infracción
                      </label>
                      <p class="txt txt--small">
                        {{infraction.infringementReporter}}
                      </p>
                      <label for="" class="label">
                        Respaldo
                      </label>
                      <p class="txt txt--small">
                        {{ infraction.evidences && infraction.evidences.join(', ').split('').reverse().join('').replace(',','y ').split('').reverse().join('')}}
                        &nbsp;
                      </p>
                      <div *ngIf="infraction.witnesses!.length > 0 || !infraction.witnesses">
                        <label for="" class="label">
                          Testigo
                        </label>
                        <p class="txt txt--small" *ngFor="let item of infraction.witnesses">
                          {{ item.mdmid+' - '+item.name }}
                        </p>
                      </div>
                    </div>

                    <div class="form">
                        <label for="" class="label">
                            Registro
                        </label>
                        <p class="txt txt--small">
                          {{infraction.dateRegister  | dateFromBack }}
                        </p>
                    </div>
                    <div class="form">
                      <label for="" class="label">
                        {{infraction.suspensionType}}
                      </label>
                      <p class="txt txt--small" *ngIf="infraction.suspensionStartAt && infraction.suspensionEndAt">
                        Del {{infraction.suspensionStartAt | dateFromBack }} al
                        {{infraction.suspensionEndAt | dateFromBack }}
                      </p>
                      <p class="txt txt--small" *ngIf="infraction.suspensionStartAt && !infraction.suspensionEndAt">
                        Desde {{infraction.suspensionStartAt | dateFromBack }}
                      </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row" *ngIf="infraction.infractionState === 1">
        <div class="col-11 offset-1">
            <div class="row">
                <div class="offset-md-8 col-md-4 u-right">
                    <a class="btn btn--primary toggle" data-id="tab-two-b" style="font-size: 18px !important;">
                        Modificar o eliminar infracción
                    </a>
                </div>
            </div>
        </div>
    </div> -->
</div>
